import { Column, Columns, Stack, Text, TextLink } from 'braid-design-system';
import type { FunctionComponent } from 'react';

interface ProductRowLinkProps {
  title: string;
  description: React.ReactElement;
  linkText: string;
  link: string;
  testId: string;
}

const ProductRowLink: FunctionComponent<ProductRowLinkProps> = ({
  title,
  description,
  linkText,
  link,
  testId,
}) => (
  <Columns space={['gutter', 'xlarge']} collapseBelow="tablet">
    <Column>
      <div data-testid={`${testId}-text`}>
        <Stack space="gutter">
          <Text weight="strong">{title}</Text>
          <Text tone="secondary">{description}</Text>
        </Stack>
      </div>
    </Column>
    <Column width="1/4">
      <Text align="right" weight="strong">
        <TextLink data-testid={testId} href={link} hitArea="large">
          {linkText}
        </TextLink>
      </Text>
    </Column>
  </Columns>
);

export default ProductRowLink;
